import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Table, TableHeader, TableBody, TableRowColumn, TableRow, TableHeaderColumn, MenuItem, IconMenu, IconButton } from 'material-ui';
import { toLaxTitleCase } from 'titlecase';
import { updateUMProps, deleteUser } from '../../../stores/settings/userManagement/actions';
import { resendConfirmationLink as resendConfirm } from '../../../stores/settings/settings-actions';
import { availableAccess } from './teamPermissionOptions';
import { writeAccessIcon, noAccessIcon, getAccessIcons, getCreateLocIcon } from '../accessIcons';

import R from 'ramda';

const styles = {
  cell: { width: '9%', padding: 0, overflow: 'visible', textAlign: 'center', borderLeft: '1px solid #D3D3D3' },
};

class SingleLocOrBuyer extends Component {

  constructor() {
    super();
    this.state = {
      sortBy: '', // name or email
      sortDirection: 'forward', // forward (a to z) or backward (z to a)
      sortedMembers: null,
    };
  }

  render() {
    const { settings, corporateAdminAccess, allLocations, isBuyer, userManagementReducer, updateProp, resendConfirmationLink, userId, removeUser, isAccom } = this.props;
    const { sortDirection, sortBy, sortedMembers } = this.state;
    const usersArray = R.propOr([], 'usersArray', userManagementReducer);
    const singleLocationInfo = R.pathOr([], [0], allLocations);
    const addUserMessage = settings.get('addUserMessage');
    const manageUsersMessage = settings.get('manageUsersMessage') ? <p style={{ color: 'green' }}>{settings.get('manageUsersMessage')}</p> : undefined;
    const sortAZZA = (field, membersToSort) => (<IconButton
      iconClassName={(R.equals(field, sortBy) && !R.equals(sortDirection, 'forward')) ? 'tc-icon-move-up' : 'tc-icon-move-down'}
      iconStyle={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px', marginTop: '5px' }}
      tooltip={R.equals(sortDirection, 'forward') ? 'A-Z' : 'Z-A'}
      onTouchTap={() => {
        const fieldName = field === 'email' ? 'email' : 'first_name';
        const sorted = R.equals(sortDirection, 'forward') ?
          membersToSort.sort((a, b) => (a[fieldName] > b[fieldName]) ? 1 : ((b[fieldName] > a[fieldName]) ? -1 : 0)) :
          membersToSort.sort((a, b) => (a[fieldName] < b[fieldName]) ? 1 : ((b[fieldName] < a[fieldName]) ? -1 : 0));
        this.setState({
          sortBy: field,
          sortDirection: R.equals(sortDirection, 'forward') ? 'backward' : 'forward',
          sortedMembers: sorted,
        });
      }}
    />);
    const users = sortedMembers ? sortedMembers : usersArray;

    return (
      <div>
        {this.props.settings.get('addUserMessage').hasOwnProperty('emailExists') && addUserMessage.emailExists === false && addUserMessage.message &&
        <p style={{ color: 'green' }}>{addUserMessage.message}</p>
        }
        {manageUsersMessage}
        <Table style={{ backgroundColor: '#fafafa' }} selectable={false} wrapperStyle={{ overflow: 'visible' }} bodyStyle={{ overflow: 'visible' }}>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              <TableHeaderColumn style={{ width: '20%', textAlign: 'center' }}>
                <span>Name</span>
                {sortAZZA('name', users)}
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '20%', textAlign: 'center' }}>
                <span>Email</span>
                {sortAZZA('email', users)}
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '12%', textAlign: 'center' }}>Status</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '12%', textAlign: 'center' }}>Team</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '9%', padding: 0, textAlign: 'center', overflow: 'hidden' }}>
                Profile
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '9%', padding: 0, textAlign: 'center', overflow: 'hidden' }}>
                User <br/> Management
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '9%', padding: 0, textAlign: 'center', overflow: 'hidden' }}>
                Contracting
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '9%' }} />
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {users.map((user, index) => {
              const status = (() => {
                if (user.status === 'pending') return 'Pending for Approval';
                if (user.status === 'approved') {
                  if (user.confirmed_at) return 'Email Confirmed';
                  return 'Email Not Confirmed';
                }
                if (user.status === 'rejected') return 'Rejected';
              })();
              const userAccess = feature => user[feature];
              const userName = user.first_name || user.last_name
                ? toLaxTitleCase(`${user.first_name} ${user.last_name}`)
                : '';
              const teamString = user.teams.sort((a, b) => {
                if (a > b) return 1;
                if (b > a) return -1;
                return 0;
              }).join(', ');
              return (
                <TableRow key={index}>
                  <TableRowColumn style={{ width: '20%' }}>
                    {userName}
                  </TableRowColumn>
                  <TableRowColumn style={{ width: '20%' }}>
                    {user.email}
                  </TableRowColumn>
                  <TableRowColumn style={{ width: '12%' }}>
                    {status}
                  </TableRowColumn>
                  <TableRowColumn style={{ width: '12%' }}>
                    {teamString}
                  </TableRowColumn>
                  <TableRowColumn style={styles.cell}>
                    {getAccessIcons(userAccess('profile'))}
                  </TableRowColumn>
                  <TableRowColumn style={styles.cell}>
                    {getAccessIcons(userAccess('admin'))}
                  </TableRowColumn>
                  <TableRowColumn style={styles.cell}>
                    {getAccessIcons(userAccess('contracting'))}
                  </TableRowColumn>
                  <TableRowColumn style={{ width: '9%', padding: 0, textAlign: 'right' }}>
                    <IconMenu
                      iconButtonElement={<IconButton
                        iconClassName="tc-icon-more-vert"
                        iconStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
                      />}
                    >
                      <MenuItem primaryText="Edit" onTouchTap={() => {
                        if (R.contains('write', corporateAdminAccess)) {
                          const obj = R.merge(user, {
                            locAccess: isBuyer ? [] : [{
                              label: R.propOr('', 'property_name', singleLocationInfo),
                              value: R.propOr('', 'property_name', singleLocationInfo),
                              locId: R.propOr('', '_id', singleLocationInfo),
                              locName: R.propOr('', 'property_name', singleLocationInfo),
                              _id: R.propOr('', '_id', singleLocationInfo),
                              profile: user.profile,
                              contracting: user.contracting,
                              teams: user.teams,
                              admin: user.admin,
                            }],
                            firstName: R.propOr('', 'first_name', user),
                            lastName: R.propOr('', 'last_name', user),
                            userId: user._id,
                          });
                          updateProp({
                            editUserDialog: true,
                            editedUser: obj,
                            originalUser: obj });
                          if (sortedMembers) this.setState({ sortedMembers: null, sortBy: '', sortDirection: 'forward' });
                        } else {
                          this.props.triggerNoAccessWarning({ noAccessDialog: true, requestingAccessToFeature: 'User Management', requestAccessData: { type: 'userAccess' } });
                        }
                      }}
                      />
                      {user.status.toLowerCase() === 'approved' && !user.confirmed_at &&
                      <MenuItem primaryText="Resend Confirmation Link" onTouchTap={() => resendConfirmationLink(user.email)} />}
                      {R.contains('write', corporateAdminAccess) && (userId !== user._id) &&
                      <MenuItem primaryText="delete user" onTouchTap={() => removeUser(user._id)} />}
                    </IconMenu>
                  </TableRowColumn>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <br />
      </div>
    );
  }
}

SingleLocOrBuyer.propTypes = {
  settings: PropTypes.object,
  userManagementReducer: PropTypes.object,
  resendConfirmationLink: PropTypes.func,
  updateProp: PropTypes.func,
  userId: PropTypes.string,
  removeUser: PropTypes.func,
  corporateAdminAccess: PropTypes.array,
  allLocations: PropTypes.array,
  isBuyer: PropTypes.bool,
  triggerNoAccessWarning: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  triggerNoAccessWarning: payload => dispatch({ type: 'GLOBAL_ERROR_TRIGGERED', payload }),
  updateProp: (...args) => dispatch(updateUMProps(...args)),
  resendConfirmationLink: (email) => dispatch(resendConfirm(email)),
  removeUser: (...args) => dispatch(deleteUser(...args)),
});

const mapStateToProps = ({ settings, user, userManagement }) => ({
  settings,
  corporateAdminAccess: user.get('corporateAdminAccess'),
  userManagementReducer: userManagement.toJS(),
  allLocations: user.get('allLocations'),
  isBuyer: user.getIn(['user', 'type']) === 'Contractor',
  userId: user.get('id'),
  isAccom: user.getIn(['company', 'productType']) === 'Accommodation',
});

export default connect(mapStateToProps, mapDispatchToProps)(SingleLocOrBuyer);



// WEBPACK FOOTER //
// ./src/app/components/settings/userManagement/singleLocOrBuyer.jsx